export enum SalaryPay {
	Annual = 1,
	Daily = 2,
}
